import { Col } from "react-bootstrap";
import { styled } from "styled-components"

export const SDivDuplicar = styled(Col)`
    display: flex;
    align-items: flex-end;
`;